module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="phx-splitA phx-proto-resizable">\r\n  <div class="phx-splitAcell phx-proto-resizable">\r\n    <div class="phx-contentPanel phx-panelA">\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class="phx-splitBcell phx-proto-resizable">\r\n  <div class="phx-splitB phx-proto-resizable">\r\n    <div class="phx-button-header"></div>\r\n    <div class="phx-contentPanel phx-panelB phx-proto-resizable">\r\n    </div>\r\n  </div>\r\n</div>';
}
return __p;
};
